module.exports = __webpack_public_path__ + "static/media/login_bg.78a137a0.svg";